<template>
    <div>
        Id2 : {{label.id}}
        <quill-editor v-model="label.value"
                ref="myQuillEditor"
                :options="editorOption"
                @blur="onEditorBlur($event)"
                @focus="onEditorFocus($event)"
                @ready="onEditorReady($event)"
                :disabled="false"
                >
        </quill-editor>
        <br/>
        <div style="float:right">
            <s-button theme="is-success" label="Enregistrer" @onclick="save"/> 
        </div>
        <div style="float:left">
            <s-button theme="is-danger" label="Supprimer" @onclick="deleteLabel"/> 
        </div>
        
    </div>
</template>

<script>


import firebase_api from "@/firebase/firebase_api"
export default {
  props: ["label"],
 
  data() {
      return {
        contentReal: null,  
        editorOption: {
            theme: 'snow',
             
             modules: {
                 
                 toolbar: [
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                [{'size': ['small', false, 'large', 'huge']}],
                 ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                 [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                 [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                 ['clean'], ['link'] 
                 ],
                 
             }
        }
    }
  },

  methods: {
      save() {
          var labels = this.$store.getters.getLabelRef;
          if (typeof(labels)=="undefined" || labels==null) {
                    labels = {};
          }
          labels[this.label.id] = this.label.value;
          firebase_api.api.getDb().collection("label").doc("fr").set(
                    labels
                ).then(()=>{
                    this.$store.dispatch("initLabel", ()=>{
                        this.$emit("close");
                })
                })
      },
      deleteLabel() {
            var labels = this.$store.getters.getLabelRef;
            if (typeof(labels[this.label.id])!="undefined") {
                if (confirm("Supprimer le libellé ?")) {
                    delete labels[this.label.id];
                    firebase_api.api.getDb().collection("label").doc("fr").set(
                        labels
                    ).then(()=>{
                        this.$emit("close");
                    })
                }
            }
        },
      onEditorBlur(quill) {
       
      },
      onEditorFocus(quill) {
       
      },
      onEditorReady(quill) {
       
      },
      onEditorChange({ quill, html, text }) {
        this.content = html
      }
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill
      },
      content: {
          get() {
            if (this.contentReal==null)
                return this.$store.getters.getEditor.value;
            else
                return this.contentReal;
          },
          set(value) {
              this.contentReal = value;
          }
      }
    },
    mounted() {
     
    }
}
</script>